var map = {
	"./page/En/about-yfc/about-yfc": [
		"RD1c",
		34
	],
	"./page/En/about-yfc/about-yfc.vue": [
		"RD1c",
		34
	],
	"./page/En/investment/finance-information/company-annual-report": [
		"N3hs",
		55
	],
	"./page/En/investment/finance-information/company-annual-report.vue": [
		"N3hs",
		55
	],
	"./page/En/investment/finance-information/financial-report": [
		"HTWw",
		52
	],
	"./page/En/investment/finance-information/financial-report.vue": [
		"HTWw",
		52
	],
	"./page/En/investment/finance-information/monthly-revenue-information": [
		"ar+n",
		97
	],
	"./page/En/investment/finance-information/monthly-revenue-information.vue": [
		"ar+n",
		97
	],
	"./page/En/investment/finance-information/monthly-surplus": [
		"LdBV",
		96
	],
	"./page/En/investment/finance-information/monthly-surplus.vue": [
		"LdBV",
		96
	],
	"./page/En/investment/shareholder-service/institutional-investors": [
		"28ie",
		38
	],
	"./page/En/investment/shareholder-service/institutional-investors.vue": [
		"28ie",
		38
	],
	"./page/En/investment/shareholder-service/material-information": [
		"ui88",
		95
	],
	"./page/En/investment/shareholder-service/material-information.vue": [
		"ui88",
		95
	],
	"./page/En/investment/shareholder-service/shareholder-structure": [
		"SZD+",
		94
	],
	"./page/En/investment/shareholder-service/shareholder-structure.vue": [
		"SZD+",
		94
	],
	"./page/En/investment/shareholder-service/shareholders-meeting": [
		"Qyqb",
		10
	],
	"./page/En/investment/shareholder-service/shareholders-meeting.vue": [
		"Qyqb",
		10
	],
	"./page/En/product-service/product-service": [
		"eUyW",
		45
	],
	"./page/En/product-service/product-service.vue": [
		"eUyW",
		45
	],
	"./page/En/site/site-tour": [
		"OO54",
		93
	],
	"./page/En/site/site-tour.vue": [
		"OO54",
		93
	],
	"./page/En/sustainability/sustainability": [
		"mIiX",
		59
	],
	"./page/En/sustainability/sustainability.vue": [
		"mIiX",
		59
	],
	"./page/Index": [
		"A3Wa",
		1
	],
	"./page/Index.vue": [
		"A3Wa",
		1
	],
	"./page/Index_en": [
		"TyQH",
		2
	],
	"./page/Index_en.vue": [
		"TyQH",
		2
	],
	"./page/Layout": [
		"Bv40",
		0
	],
	"./page/Layout.vue": [
		"Bv40",
		0
	],
	"./page/Tw/about-tac/certificate": [
		"ysEt",
		92
	],
	"./page/Tw/about-tac/certificate.vue": [
		"ysEt",
		92
	],
	"./page/Tw/about-tac/management-group": [
		"MuZJ",
		61
	],
	"./page/Tw/about-tac/management-group----old": [
		"rllq",
		91
	],
	"./page/Tw/about-tac/management-group----old.vue": [
		"rllq",
		91
	],
	"./page/Tw/about-tac/management-group.vue": [
		"MuZJ",
		61
	],
	"./page/Tw/about-tac/management-philosophy": [
		"VZUw",
		27
	],
	"./page/Tw/about-tac/management-philosophy.vue": [
		"VZUw",
		27
	],
	"./page/Tw/about-tac/news-center": [
		"xevI",
		5
	],
	"./page/Tw/about-tac/news-center.vue": [
		"xevI",
		5
	],
	"./page/Tw/about-tac/related-company": [
		"uCLN",
		90
	],
	"./page/Tw/about-tac/related-company.vue": [
		"uCLN",
		90
	],
	"./page/Tw/about-tac/service-dealer": [
		"o2vK",
		50
	],
	"./page/Tw/about-tac/service-dealer.vue": [
		"o2vK",
		50
	],
	"./page/Tw/business/business": [
		"HD2X",
		29
	],
	"./page/Tw/business/business.vue": [
		"HD2X",
		29
	],
	"./page/Tw/investment/company-information/company-info": [
		"cDVw",
		89
	],
	"./page/Tw/investment/company-information/company-info.vue": [
		"cDVw",
		89
	],
	"./page/Tw/investment/company-information/credit-rating": [
		"BLKP",
		88
	],
	"./page/Tw/investment/company-information/credit-rating.vue": [
		"BLKP",
		88
	],
	"./page/Tw/investment/company-information/csr-download": [
		"QrbU",
		87
	],
	"./page/Tw/investment/company-information/csr-download.vue": [
		"QrbU",
		87
	],
	"./page/Tw/investment/company-information/identification-of-stakeholders": [
		"yWQG",
		86
	],
	"./page/Tw/investment/company-information/identification-of-stakeholders.vue": [
		"yWQG",
		86
	],
	"./page/Tw/investment/finance-information/company-annual-report": [
		"WUEQ",
		85
	],
	"./page/Tw/investment/finance-information/company-annual-report.vue": [
		"WUEQ",
		85
	],
	"./page/Tw/investment/finance-information/financial-report": [
		"96fF",
		44
	],
	"./page/Tw/investment/finance-information/financial-report.vue": [
		"96fF",
		44
	],
	"./page/Tw/investment/finance-information/monthly-revenue-information": [
		"0Ilh",
		84
	],
	"./page/Tw/investment/finance-information/monthly-revenue-information.vue": [
		"0Ilh",
		84
	],
	"./page/Tw/investment/finance-information/monthly-surplus": [
		"QktP",
		40
	],
	"./page/Tw/investment/finance-information/monthly-surplus.vue": [
		"QktP",
		40
	],
	"./page/Tw/investment/shareholder-service/dividend-distribution": [
		"Ub2N",
		54
	],
	"./page/Tw/investment/shareholder-service/dividend-distribution.vue": [
		"Ub2N",
		54
	],
	"./page/Tw/investment/shareholder-service/institutional-investors": [
		"EZBJ",
		30
	],
	"./page/Tw/investment/shareholder-service/institutional-investors.vue": [
		"EZBJ",
		30
	],
	"./page/Tw/investment/shareholder-service/material-information": [
		"+Za0",
		57
	],
	"./page/Tw/investment/shareholder-service/material-information.vue": [
		"+Za0",
		57
	],
	"./page/Tw/investment/shareholder-service/operational-summary": [
		"RmS+",
		49
	],
	"./page/Tw/investment/shareholder-service/operational-summary.vue": [
		"RmS+",
		49
	],
	"./page/Tw/investment/shareholder-service/shareholder-structure": [
		"e8Ac",
		83
	],
	"./page/Tw/investment/shareholder-service/shareholder-structure.vue": [
		"e8Ac",
		83
	],
	"./page/Tw/investment/shareholder-service/shareholders-meeting": [
		"lhmd",
		9
	],
	"./page/Tw/investment/shareholder-service/shareholders-meeting.vue": [
		"lhmd",
		9
	],
	"./page/Tw/investment/shareholder-service/stock-affairs": [
		"igOA",
		82
	],
	"./page/Tw/investment/shareholder-service/stock-affairs.vue": [
		"igOA",
		82
	],
	"./page/Tw/investment/shareholder-service/stock-price-information": [
		"5fHk",
		81
	],
	"./page/Tw/investment/shareholder-service/stock-price-information.vue": [
		"5fHk",
		81
	],
	"./page/Tw/product-service/cn-business/cn-car-rent": [
		"yWTS",
		80
	],
	"./page/Tw/product-service/cn-business/cn-car-rent.vue": [
		"yWTS",
		80
	],
	"./page/Tw/product-service/cn-business/cn-carloan-installments": [
		"iVDG",
		79
	],
	"./page/Tw/product-service/cn-business/cn-carloan-installments.vue": [
		"iVDG",
		79
	],
	"./page/Tw/product-service/cn-business/cn-equipment-leasing": [
		"ffnB",
		78
	],
	"./page/Tw/product-service/cn-business/cn-equipment-leasing.vue": [
		"ffnB",
		78
	],
	"./page/Tw/product-service/cn-business/cn-vehicle-auction": [
		"MvBf",
		77
	],
	"./page/Tw/product-service/cn-business/cn-vehicle-auction.vue": [
		"MvBf",
		77
	],
	"./page/Tw/product-service/ph-business/ph-carloan-installments": [
		"IBBT",
		76
	],
	"./page/Tw/product-service/ph-business/ph-carloan-installments.vue": [
		"IBBT",
		76
	],
	"./page/Tw/product-service/product-service": [
		"wSZu",
		48
	],
	"./page/Tw/product-service/product-service.vue": [
		"wSZu",
		48
	],
	"./page/Tw/product-service/tw-business/car-shop": [
		"Ny1g",
		75
	],
	"./page/Tw/product-service/tw-business/car-shop.vue": [
		"Ny1g",
		75
	],
	"./page/Tw/product-service/tw-business/energy-service": [
		"VX9G",
		74
	],
	"./page/Tw/product-service/tw-business/energy-service.vue": [
		"VX9G",
		74
	],
	"./page/Tw/product-service/tw-business/taiwan-car-rent": [
		"HwU3",
		73
	],
	"./page/Tw/product-service/tw-business/taiwan-car-rent.vue": [
		"HwU3",
		73
	],
	"./page/Tw/product-service/tw-business/taiwan-carloan-installments": [
		"rDOi",
		72
	],
	"./page/Tw/product-service/tw-business/taiwan-carloan-installments.vue": [
		"rDOi",
		72
	],
	"./page/Tw/product-service/tw-business/taiwan-corporate-finance": [
		"6Wpi",
		71
	],
	"./page/Tw/product-service/tw-business/taiwan-corporate-finance.vue": [
		"6Wpi",
		71
	],
	"./page/Tw/product-service/tw-business/taiwan-product-installments": [
		"4xCS",
		70
	],
	"./page/Tw/product-service/tw-business/taiwan-product-installments.vue": [
		"4xCS",
		70
	],
	"./page/Tw/product-service/tw-business/tw-equipment-leasing": [
		"yFcv",
		69
	],
	"./page/Tw/product-service/tw-business/tw-equipment-leasing.vue": [
		"yFcv",
		69
	],
	"./page/Tw/recruiting/nurture": [
		"ulMe",
		37
	],
	"./page/Tw/recruiting/nurture.vue": [
		"ulMe",
		37
	],
	"./page/Tw/recruiting/recruit": [
		"EI4U",
		68
	],
	"./page/Tw/recruiting/recruit.vue": [
		"EI4U",
		68
	],
	"./page/Tw/recruiting/recruit_new2": [
		"NodO",
		4
	],
	"./page/Tw/recruiting/recruit_new2.vue": [
		"NodO",
		4
	],
	"./page/Tw/recruiting/salary": [
		"sx8o",
		56
	],
	"./page/Tw/recruiting/salary.vue": [
		"sx8o",
		56
	],
	"./page/Tw/recruiting/talent-sustainability": [
		"aw+a",
		26
	],
	"./page/Tw/recruiting/talent-sustainability.vue": [
		"aw+a",
		26
	],
	"./page/Tw/site/site-tour": [
		"dOWE",
		67
	],
	"./page/Tw/site/site-tour.vue": [
		"dOWE",
		67
	],
	"./page/Tw/stakeholder/stakeholder": [
		"CAqE",
		32
	],
	"./page/Tw/stakeholder/stakeholder.vue": [
		"CAqE",
		32
	],
	"./page/Tw/sustainable-development/customer-worth/aaaTest": [
		"/Zxw",
		60
	],
	"./page/Tw/sustainable-development/customer-worth/aaaTest.vue": [
		"/Zxw",
		60
	],
	"./page/Tw/sustainable-development/customer-worth/customer-privacy": [
		"fPtL",
		46
	],
	"./page/Tw/sustainable-development/customer-worth/customer-privacy.vue": [
		"fPtL",
		46
	],
	"./page/Tw/sustainable-development/customer-worth/customer-relationship": [
		"m1Lu",
		17
	],
	"./page/Tw/sustainable-development/customer-worth/customer-relationship.vue": [
		"m1Lu",
		17
	],
	"./page/Tw/sustainable-development/customer-worth/customer-service": [
		"pdRf",
		24
	],
	"./page/Tw/sustainable-development/customer-worth/customer-service.vue": [
		"pdRf",
		24
	],
	"./page/Tw/sustainable-development/environment-sustainable/carbon-reduction": [
		"Oc7o",
		62
	],
	"./page/Tw/sustainable-development/environment-sustainable/carbon-reduction.vue": [
		"Oc7o",
		62
	],
	"./page/Tw/sustainable-development/environment-sustainable/climate-change": [
		"HX+V",
		20
	],
	"./page/Tw/sustainable-development/environment-sustainable/climate-change.vue": [
		"HX+V",
		20
	],
	"./page/Tw/sustainable-development/environment-sustainable/development-green-energy": [
		"X8TI",
		8
	],
	"./page/Tw/sustainable-development/environment-sustainable/development-green-energy.vue": [
		"X8TI",
		8
	],
	"./page/Tw/sustainable-development/environment-sustainable/environmental-protection": [
		"02mD",
		7
	],
	"./page/Tw/sustainable-development/environment-sustainable/environmental-protection.vue": [
		"02mD",
		7
	],
	"./page/Tw/sustainable-development/environment-sustainable/green-sustainable": [
		"rtwt",
		43
	],
	"./page/Tw/sustainable-development/environment-sustainable/green-sustainable.vue": [
		"rtwt",
		43
	],
	"./page/Tw/sustainable-development/environment-sustainable/supplier-management": [
		"9Ad+",
		14
	],
	"./page/Tw/sustainable-development/environment-sustainable/supplier-management.vue": [
		"9Ad+",
		14
	],
	"./page/Tw/sustainable-development/happy-workplace/cultivation-and-development": [
		"uBUO",
		22
	],
	"./page/Tw/sustainable-development/happy-workplace/cultivation-and-development.vue": [
		"uBUO",
		22
	],
	"./page/Tw/sustainable-development/happy-workplace/employee-care": [
		"56Av",
		15
	],
	"./page/Tw/sustainable-development/happy-workplace/employee-care.vue": [
		"56Av",
		15
	],
	"./page/Tw/sustainable-development/happy-workplace/human-right": [
		"Wpo0",
		33
	],
	"./page/Tw/sustainable-development/happy-workplace/human-right.vue": [
		"Wpo0",
		33
	],
	"./page/Tw/sustainable-development/happy-workplace/human-structure": [
		"sobo",
		35
	],
	"./page/Tw/sustainable-development/happy-workplace/human-structure.vue": [
		"sobo",
		35
	],
	"./page/Tw/sustainable-development/happy-workplace/industrial-relations": [
		"q5s/",
		47
	],
	"./page/Tw/sustainable-development/happy-workplace/industrial-relations.vue": [
		"q5s/",
		47
	],
	"./page/Tw/sustainable-development/operating-governance/compliance": [
		"X2mK",
		31
	],
	"./page/Tw/sustainable-development/operating-governance/compliance.vue": [
		"X2mK",
		31
	],
	"./page/Tw/sustainable-development/operating-governance/corporate-governance": [
		"gEgt",
		28
	],
	"./page/Tw/sustainable-development/operating-governance/corporate-governance.vue": [
		"gEgt",
		28
	],
	"./page/Tw/sustainable-development/operating-governance/information-disclosure": [
		"zmQa",
		66
	],
	"./page/Tw/sustainable-development/operating-governance/information-disclosure.vue": [
		"zmQa",
		66
	],
	"./page/Tw/sustainable-development/operating-governance/integrity-management": [
		"M0SZ",
		18
	],
	"./page/Tw/sustainable-development/operating-governance/integrity-management.vue": [
		"M0SZ",
		18
	],
	"./page/Tw/sustainable-development/operating-governance/it-security": [
		"VjSD",
		51
	],
	"./page/Tw/sustainable-development/operating-governance/it-security.vue": [
		"VjSD",
		51
	],
	"./page/Tw/sustainable-development/operating-governance/risk-management": [
		"RQ1p",
		16
	],
	"./page/Tw/sustainable-development/operating-governance/risk-management.vue": [
		"RQ1p",
		16
	],
	"./page/Tw/sustainable-development/operating-governance/succession-plan": [
		"MTon",
		65
	],
	"./page/Tw/sustainable-development/operating-governance/succession-plan.vue": [
		"MTon",
		65
	],
	"./page/Tw/sustainable-development/society-join/charitable-activities": [
		"86qc",
		21
	],
	"./page/Tw/sustainable-development/society-join/charitable-activities.vue": [
		"86qc",
		21
	],
	"./page/Tw/sustainable-development/society-join/faas": [
		"Pfnj",
		13
	],
	"./page/Tw/sustainable-development/society-join/faas.vue": [
		"Pfnj",
		13
	],
	"./page/Tw/sustainable-development/society-join/rural-connection": [
		"ccHU",
		6
	],
	"./page/Tw/sustainable-development/society-join/rural-connection.vue": [
		"ccHU",
		6
	],
	"./page/Tw/sustainable-development/society-join/social-impact": [
		"MkQS",
		58
	],
	"./page/Tw/sustainable-development/society-join/social-impact.vue": [
		"MkQS",
		58
	],
	"./page/Tw/sustainable-development/society-join/sports-training": [
		"Ec7t",
		12
	],
	"./page/Tw/sustainable-development/society-join/sports-training.vue": [
		"Ec7t",
		12
	],
	"./page/Tw/sustainable-development/society-join/strategy": [
		"hcbO",
		64
	],
	"./page/Tw/sustainable-development/society-join/strategy.vue": [
		"hcbO",
		64
	],
	"./page/Tw/sustainable-development/supplier-management/chart-test": [
		"T4YR",
		63
	],
	"./page/Tw/sustainable-development/supplier-management/chart-test.vue": [
		"T4YR",
		63
	],
	"./page/Tw/sustainable-development/supplier-management/supplier-policy": [
		"m9Wq",
		11
	],
	"./page/Tw/sustainable-development/supplier-management/supplier-policy.vue": [
		"m9Wq",
		11
	],
	"./page/Tw/sustainable-development/supplier-management/supplier-result": [
		"zvbl",
		53
	],
	"./page/Tw/sustainable-development/supplier-management/supplier-result.vue": [
		"zvbl",
		53
	],
	"./page/Tw/sustainable-development/sustainable-operating/csr-download": [
		"YJhA",
		42
	],
	"./page/Tw/sustainable-development/sustainable-operating/csr-download.vue": [
		"YJhA",
		42
	],
	"./page/Tw/sustainable-development/sustainable-operating/operators": [
		"3KTC",
		39
	],
	"./page/Tw/sustainable-development/sustainable-operating/operators.vue": [
		"3KTC",
		39
	],
	"./page/Tw/sustainable-development/sustainable-operating/significant-issue": [
		"F8qH",
		19
	],
	"./page/Tw/sustainable-development/sustainable-operating/significant-issue.vue": [
		"F8qH",
		19
	],
	"./page/Tw/sustainable-development/sustainable-operating/stakeholder-channel": [
		"OQKU",
		41
	],
	"./page/Tw/sustainable-development/sustainable-operating/stakeholder-channel.vue": [
		"OQKU",
		41
	],
	"./page/Tw/sustainable-development/sustainable-operating/stakeholder-identification": [
		"5/tB",
		23
	],
	"./page/Tw/sustainable-development/sustainable-operating/stakeholder-identification.vue": [
		"5/tB",
		23
	],
	"./page/Tw/sustainable-development/sustainable-operating/sustainable-introduction": [
		"YuT8",
		36
	],
	"./page/Tw/sustainable-development/sustainable-operating/sustainable-introduction.vue": [
		"YuT8",
		36
	],
	"./page/Tw/sustainable-development/sustainable-operating/sustainable-performance": [
		"RIc8",
		3
	],
	"./page/Tw/sustainable-development/sustainable-operating/sustainable-performance.vue": [
		"RIc8",
		3
	],
	"./page/Tw/sustainable-development/sustainable-operating/sustainable-strategy-operation": [
		"dZcQ",
		25
	],
	"./page/Tw/sustainable-development/sustainable-operating/sustainable-strategy-operation.vue": [
		"dZcQ",
		25
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "hZ8o";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy ^\.\/page.*$
// module id = hZ8o
// module chunks = 99